export default () => {
  const init = () => {
    const target = document.querySelector('body');

    const config = {
      attributes: true,
      childList: true,
      subtree: true,
    };

    const callback = (mutationsList, observer) => {
      observer.disconnect();

      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const mutationTarget = document.getElementsByClassName(
            'yotpo-modal-user-details',
          );
          if (mutationTarget.length > 0) {
            Array.from(mutationTarget).forEach((element) => {
              if (!element.querySelector('.mutation-el')) {
                const mutationEl = document.createElement('div');
                mutationEl.className = 'mutation-el yotpo-modal-subtitle';
                mutationEl.textContent =
                  window.TMW.Strings.customer.providedInformation;
                element.appendChild(mutationEl);
              }
            });
          }
        }
      }

      observer.observe(target, config);
    };

    const observer = new MutationObserver(callback);
    observer.observe(target, config);
  };

  init();
};
